import React from 'react';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import { useLogoutContext } from 'Context/LogoutContext';

const CombinedAppDebugPanel = () => {
  const { logout } = useLogoutContext();
  return (
    <FDPrimaryActionButton
      label={'Log Out'}
      onClick={() => {
        logout();
      }}
    />
  );
};

export default CombinedAppDebugPanel;
